/* eslint-disable security/detect-object-injection */
import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { Link } from '@jutro/router';
import { InputField, DateField, Icon } from '@jutro/legacy/components';
import styles from './FormerEntityTableComponent.module.scss';
import metadata from './FormerEntityTableComponent.metadata.json5';

function FormerEntityTableComponent(props) {

    const {
        formerEntityTableVisible,
        data: FormerEntityTableVM,
        updateWizardData,
        submissionVM,
        FormerEntityTablePath,
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);


    const addFormerEntityTable = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            FormerEntityTableVM.value = FormerEntityTableVM.value || []

            const { _xCenter, _dtoName } = FormerEntityTableVM;

            const FormerEntityTableObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            FormerEntityTableObjVM.isValidationReq = true;

            FormerEntityTableVM.pushElement(
                FormerEntityTableObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, FormerEntityTableVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            FormerEntityTableVM.value.splice(index, 1);
            _.set(submissionVM.value, FormerEntityTablePath, FormerEntityTableVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, FormerEntityTablePath, FormerEntityTableVM?.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'number') {
                const formerEntityArray = _.get(submissionVM.value, FormerEntityTablePath);
                const newNumber = formerEntityArray?.length >= 2 ? formerEntityArray[formerEntityArray.length - 2].number + 1 : index + 1;

                if (formerEntityArray[index].number === undefined) {
                    formerEntityArray[index].number = newNumber;
                    _.set(submissionVM.value, FormerEntityTablePath, FormerEntityTableVM.value);
                }

                const value = item.number ? item.number : newNumber;

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        value={value}
                        readOnly
                    />
                );
            }

            if (path === 'namOfFir2') {
                const value = item.namOfFir2 ? item.namOfFir2 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.namOfFir2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'datEst3') {
                const value = item.datEst3 ? item.datEst3 : '';

                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType='object'
                        path={path}
                        format="short"
                        layout="full-width"
                        showOptional={false}
                        onValueChange={(val, changedPath) => {
                            item.datEst3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }

            if (path === 'datCeaOpe4') {
                const value = item.datCeaOpe4 ? item.datCeaOpe4 : '';

                return (
                    <DateField
                        id={index + path}
                        value={value}
                        dataType='object'
                        path={path}
                        format="short"
                        layout="full-width"
                        showOptional={false}
                        onValueChange={(val, changedPath) => {
                            item.datCeaOpe4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                    />
                );
            }

            if (path === 'expOfSit5') {
                const value = item.expOfSit5 ? item.expOfSit5 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.expOfSit5 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }


        }, [submissionVM.value, handleValueChange])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            (<Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>)
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`FormerEntityTableTable`]: {
            data: FormerEntityTableVM.value,
        },
        addFormerEntityTableContainer: {
            visible: formerEntityTableVisible
        }
    }), [FormerEntityTableVM.value, formerEntityTableVisible])

    const resolvers = {
        resolveCallbackMap: {
            addFormerEntityTable,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            FormerEntityTableVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [FormerEntityTableVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={FormerEntityTableVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

FormerEntityTableComponent.propTypes = wizardProps;
export default withRouter(FormerEntityTableComponent);
